/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import HeaderComponent from '../components/table/header/headerComponent';

import NewUsersComponent from '../components/parameters/NewUsers';
import PlacesPage from '../components/parameters/Places';
import GeneralComponent from '../components/parameters/General';
import AutomatedFollowUp from '../components/parameters/AutomatedFollowUp';
import LeadTime from '../components/parameters/LeadTime';

class Parameters extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      newUsers: false,
      places: false,
      general: true,
      automatedFollowUp: false,
      leadTime: false,
    };
  }

  componentDidMount() {
    const { page } = this.props.location;
    if (page) this.setPage(page);
  }

  setPage = (page) => {
    if (page === 'newUsers') {
      this.setState({
        newUsers: true,
        places: false,
        general: false,
      });
    }
    if (page === 'places') {
      this.setState({
        newUsers: false,
        places: true,
        general: false,
      });
    }
    if (page === 'general') {
      this.setState({
        newUsers: false,
        places: false,
        general: true,
      });
    }
    if (page === 'automatedFollowUp') {
      this.setState({
        newUsers: false,
        places: false,
        general: false,
        automatedFollowUp: true,
      });
    }
    if (page === 'leadTime') {
      this.setState({
        newUsers: false,
        places: false,
        general: false,
        automatedFollowUp: false,
        leadTime: true,
      });
    }
  };

  render() {
    const {
      newUsers, places, general, automatedFollowUp, leadTime,
    } = this.state;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent title={I18n.t('params')} />
          <Fragment>
            <nav>
              <div
                className="nav nav-tabs"
                id="nav-tab"
                role="tablist"
                style={{ background: 'white' }}
              >
                <button
                  type="button"
                  className={`nav-item nav-link ${general ? 'active' : ''}`}
                  id="nav-general-tab"
                  data-toggle="tab"
                  href="#nav-general"
                  role="tab"
                  aria-controls="nav-general"
                  aria-selected="true"
                  onClick={() => this.setPage('general')}
                >
                  <Translate value="general" />
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${newUsers ? 'active' : ''}`}
                  id="nav-new-users-tab"
                  data-toggle="tab"
                  href="#nav-new-users"
                  role="tab"
                  aria-controls="nav-new-users"
                  aria-selected="true"
                  onClick={() => this.setPage('newUsers')}
                >
                  <Translate value="newUsers" />
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${places ? 'active' : ''}`}
                  id="nav-places-tab"
                  data-toggle="tab"
                  href="#nav-places"
                  role="tab"
                  aria-controls="nav-places"
                  aria-selected="true"
                  onClick={() => this.setPage('places')}
                >
                  <Translate value="places" />
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${leadTime ? 'active' : ''}`}
                  id="nav-leadTime-tab"
                  data-toggle="tab"
                  href="#nav-leadTime"
                  role="tab"
                  aria-controls="nav-leadTime"
                  aria-selected="true"
                  onClick={() => this.setPage('leadTime')}
                >
                  <Translate value="leadTime" />
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${automatedFollowUp ? 'active' : ''}`}
                  id="nav-automated-follow-up-tab"
                  data-toggle="tab"
                  href="#nav-automated-follow-up"
                  role="tab"
                  aria-controls="nav-automated-follow-up"
                  aria-selected="true"
                  onClick={() => this.setPage('automatedFollowUp')}
                >
                  <Translate value="configuracionCorreosAutomaticos" />
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className={`tab-pane fade ${newUsers ? 'show active' : ''}`}
                id="nav-new-users"
                role="tabpanel"
                aria-labelledby="nav-new-users-tab"
              >
                <div className="margin-top-20 ">
                  <NewUsersComponent />
                </div>
              </div>
              <div
                className={`tab-pane fade ${places ? 'show active' : ''}`}
                id="nav-places"
                role="tabpanel"
                aria-labelledby="nav-places-tab"
              >
                <PlacesPage />
              </div>
              <div
                className={`tab-pane fade ${leadTime ? 'show active' : ''}`}
                id="nav-leadTime"
                role="tabpanel"
                aria-labelledby="nav-lead-time-tab"
              >
                <LeadTime />
              </div>
              <div
                className={`tab-pane fade ${general ? 'show active' : ''}`}
                id="nav-general"
                role="tabpanel"
                aria-labelledby="nav-general-tab"
              >
                <GeneralComponent />
              </div>
              <div
                className={`tab-pane fade ${automatedFollowUp ? 'show active' : ''}`}
                id="nav-automated-follow-up"
                role="tabpanel"
                aria-labelledby="nav-automated-follow-up-tab"
              >
                <AutomatedFollowUp />
              </div>
            </div>
          </Fragment>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
});

export default connect(mapStateToProps)(Parameters);
